export const SYNC_SECURITY_OPTIONS_CONDITIONS = '@@securityOptionsConditions/syncSecurityOptionsConditions'
export const UPDATE_SECURITY_OPTIONS_CONDITIONS = '@@securityOptionsConditions/updateSecurityOptionsConditions'
